import {
  Label1,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from '@sainsburys-tech/fable'
import { Close, Tick } from '@sainsburys-tech/icons'
import React from 'react'

import Incrementor from '../../../hotfood/components/Production/Incrementor'

interface IProps {
  skus: {
    skuId: number
    skuName: string
    quantity: number
  }[]
  onChange: (skuId: number, value: number) => void
  isSkuInAdditionalWave: (skuId: number) => boolean
}

const AdditionalWaveTable: React.FC<IProps> = ({
  skus,
  onChange,
  isSkuInAdditionalWave,
}) => {
  if (!skus.length) return null

  return (
    <div className='c-additional-wave-table-wrapper'>
      <Table
        style={{ marginTop: '1.5rem' }}
        testid='additional-wave-table'
        className='c-bakery-additional-wave-table'
        layout={'auto'}
      >
        <TableHeader>
          <TableRow>
            <TableCell className='c-additional-wave-in-wave'>
              <Label1>In Wave</Label1>
            </TableCell>
            <TableCell className='c-additional-wave-product'>
              <Label1>Product</Label1>
            </TableCell>
            <TableCell className='c-additional-wave-sku'>
              <Label1>SKU Code</Label1>
            </TableCell>
            <TableCell className='c-additional-wave-quantity'>
              <Label1>Quantity</Label1>
            </TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {skus.map((sku) => (
            <TableRow key={sku.skuId}>
              <TableCell className='c-additional-wave-in-wave-status'>
                {isSkuInAdditionalWave(sku.skuId) || sku.quantity > 0 ? (
                  <Tick
                    style={{
                      width: '20px',
                      height: '20px',
                      color: 'var(--fable-color-background-success-bold)',
                    }}
                    aria-label='Included in wave'
                  />
                ) : (
                  <Close
                    style={{
                      width: '20px',
                      height: '20px',
                      color: 'var(--fable-color-background-error-bold-default)',
                    }}
                    aria-label='Not included in wave'
                  />
                )}
              </TableCell>
              <TableCell className='c-additional-wave-sku-name'>
                {sku.skuName}
              </TableCell>
              <TableCell className='c-additional-wave-sku-id'>
                {sku.skuId}
              </TableCell>
              <TableCell className='c-additional-wave-sku-quantity'>
                <Incrementor
                  id={sku.skuId}
                  step={1}
                  value={sku.quantity}
                  setValue={onChange}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}

export default AdditionalWaveTable
